import Vue from "vue";

// We don't need to do UTC-8 as that is the expected encoding type to begin with.
const validEncodeTypes = ["UTF-8", "Windows-1252"];

// Unicode code for �
const INVALID_CHAR = "%uFFFD";

export const downloadCsv = (name: string, headers: string[]): void => {
    const encodedUri = encodeURI("data:text/csv;charset=utf-8,"+ headers.join(","));
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${name}.csv`);
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file named "my_data.csv".
}

/**
 * Method to identify if the data is valid
 * @param file the file we are checking
 * @returns returns a new file if encoded correctly, otherwise returns passed in file.
 */
export const identifyAndEncode = async (file: File) => {
    let failureCount = 0;
    for (let index = 0; index < validEncodeTypes.length; index++) {
        const fileData = await FileReaderOnwait(file, validEncodeTypes[index]);

        // confirm if it's the right encode type.
        const isvalidtest = isInvalidEncode(fileData);
        if(isvalidtest) {
            failureCount++;
            // Attempt to transform using 'Windows-1252'
            continue;
        }

        const fileDataBlob = new Blob([fileData]);
        return new File([fileDataBlob], file.name);
    }

    // If we can't encode it, return the default file.
    // (Hope it works magically on the backend!)
    if (failureCount === validEncodeTypes.length) {
        Vue.prototype.$notify({
            type: "warning",
            title: "Encoding issue",
            text: "Possible issue with the encoding type of uploaded file"
        });
    }

    return file;
}

/**
 * Method which wraps FileReader which solves callback hell
 * Used to read data and transform to the encoding type provided
 * @param file The file we are reading from.
 * @param encodeType The encode type we are going to transform to.
 * @returns Promise - encoded data as a string
 */
 export const FileReaderOnwait = async (file: File, encodeType: string) => {
    const onLoadWait = (): Promise<string> => new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = event =>  res(event.target.result as string);
        reader.readAsText(file, encodeType);
        reader.onerror = rej;
    });

    return await onLoadWait();
}

// Escape data and check if it contains a invalid char
export const isInvalidEncode = (fileData: string) => escape(fileData).includes(INVALID_CHAR);